var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible && _vm.channelVisible)?_c('div',{staticClass:"page-builder-group",class:[
       _vm.inAnimate ? `animate__animated animate__${_vm.inAnimate}` : '',
       _vm.hoverClass,
       _vm.autoAnimate
       ],style:(_vm.style),on:{"mouseover":function($event){_vm.hoverAnimate ? _vm.hoverClass =  _vm.hoverAnimate : ''},"mouseout":function($event){_vm.hoverClass = ''},"click":_vm.handleClick}},[_vm._t("default",function(){return [_c('div',{staticClass:"default-area"},[_vm._v("组-占位区")])]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }